import * as React from 'react';
import { FC } from 'react';

interface NumberOfPortionsModel {
    portions: number,
    setPortions: React.Dispatch<React.SetStateAction<number>>;
}

const NumberOfPortions: FC<NumberOfPortionsModel> = (props) => {

    return (
        <div className="flex items-center justify-center gap-4 mb-6">
            <div>
                <button type="button" title="Treff fra en posjon" className="btn-primary !rounded-full  !p-2 w-10 h-10" onClick={() => props.setPortions(props.portions - 1)} disabled={props.portions === 1 ? true : false} >
                    <span className="sr-only">
                        Trekk fra en posjon
                    </span>

                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                        <mask id="mask0_721_36751" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
                            <rect x="0.5" y="0.786682" width="24" height="24" fill="#D9D9D9"/>
                        </mask>
                        <g mask="url(#mask0_721_36751)">
                            <path d="M5.5 13.7867V11.7867H19.5V13.7867H5.5Z" fill="#555555"/>
                        </g>
                    </svg>
                </button>                            
            </div>

            <form className="flex flex-col max-w-[120px]">
                <label htmlFor="portions" className="sr-only">Antall porsjoner</label>
                <input id="portions" type="text" value={props.portions} onChange={(e) => props.setPortions(Number(e.target.value))} className="text-5xl font-bold text-center border-2 border-brown-25 bg-transparent rounded-lg focus:bg-yellow-25 focus:border-2 focus:border-brown-secondary" />
                <span className="text-base text-center">posjoner</span>
            </form>

            <div>
                <button type="button" title="Legg til en posjon" className="btn-primary !rounded-full !p-2 w-10 h-10" onClick={() => props.setPortions(props.portions + 1)} disabled={props.portions === 50 ? true : false}>
                    <span className="sr-only">
                        Legg til en posjon
                    </span>

                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                        <mask id="mask0_721_36758" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
                            <rect x="0.5" y="0.786682" width="24" height="24" fill="#D9D9D9"/>
                        </mask>
                        <g mask="url(#mask0_721_36758)">
                            <path d="M11.5 13.7867H5.5V11.7867H11.5V5.78668H13.5V11.7867H19.5V13.7867H13.5V19.7867H11.5V13.7867Z" fill="#555555"/>
                        </g>
                    </svg>                          
                </button>
            </div>
        </div>
    );
};
export default NumberOfPortions;